import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { buildProfileInfoAdornment } from "../../profileInfoAdornment";
import {
  profileReadOnlyFieldBoxSx,
  profileReadOnlyTextFieldSx,
  profileReadOnlyValueSx,
} from "../../profileFieldStyles";

const EMPTY_DISPLAY = "—";

export function formatReadOnlyValue(value, { mask = false } = {}) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return EMPTY_DISPLAY;
  if (mask) return "••••••••";
  return trimmed;
}

export function ProfileReadOnlyValueBox({ children }) {
  return (
    <Box sx={profileReadOnlyFieldBoxSx}>
      <Typography component="p" sx={profileReadOnlyValueSx}>
        {children}
      </Typography>
    </Box>
  );
}

export function ProfileReadOnlyField({
  label,
  value,
  tooltip,
  mask = false,
  gridSize = { xs: 12, md: 6 },
  fieldId,
}) {
  const display = formatReadOnlyValue(value, { mask });
  const id = fieldId || `vendor-readonly-${String(label).replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <Grid2 {...gridSize}>
      <TextField
        id={id}
        label={label}
        value={display}
        fullWidth
        variant="outlined"
        size="medium"
        sx={profileReadOnlyTextFieldSx}
        InputLabelProps={{ shrink: true }}
        inputProps={{ readOnly: true, "aria-readonly": true }}
        InputProps={{
          readOnly: true,
          endAdornment: buildProfileInfoAdornment(tooltip),
        }}
      />
    </Grid2>
  );
}
